module.exports.app_id = "DEX";

module.exports.api_url = "https://dex-api.polymedia.nl";
module.exports.api_token = "8j8Vruh1F8TdQ9O3";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://localhost:3001";
	module.exports.api_token = "456";
}



// WEBPACK FOOTER //
// ./src/config.js